import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Mission from './components/Mission';
import About from './components/About';
import GeneticTesting from './components/GeneticTesting';
import Resources from './components/Resources';
import Community from './components/Community';
import Footer from './components/Footer';

export default function HomePage() {
  useSEO({
    title: 'CSCF Support | Cardiospondylocarpofacial Syndrome Community & Resources',
    description:
      'A support community for families affected by Cardiospondylocarpofacial syndrome (CSCF). Resources, information, and connection for this rare genetic condition.',
    keywords:
      'Cardiospondylocarpofacial syndrome, CSCF, CSCFS, MAP3K7, rare genetic condition, rare disease support, CSCF community, CSCF families, TAK1 gene',
    canonical: 'https://cscfsupport.org/',
    ogImage: SOCIAL_IMAGE,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'CSCF Support — Home',
      url: 'https://cscfsupport.org/',
      description:
        'A support community for families affected by Cardiospondylocarpofacial syndrome (CSCF). Resources, information, and connection for this rare genetic condition.',
      isPartOf: { '@type': 'WebSite', name: 'CSCF Support', url: 'https://cscfsupport.org/' },
      about: {
        '@type': 'MedicalCondition',
        name: 'Cardiospondylocarpofacial Syndrome',
        alternateName: ['CSCF', 'CSCFS'],
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Mission />
      <About />
      <GeneticTesting />
      <Resources />
      <Community />
      <Footer />
    </div>
  );
}
